import { render, staticRenderFns } from "./TourWindow.vue?vue&type=template&id=18d1350a&scoped=true"
import script from "./TourWindow.vue?vue&type=script&lang=js"
export * from "./TourWindow.vue?vue&type=script&lang=js"
import style0 from "./TourWindow.vue?vue&type=style&index=0&id=18d1350a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d1350a",
  null
  
)

export default component.exports